/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    p: "p",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "支持的 CSS(Supported CSS)"
    }), "\n", _jsx(_components.p, {
      children: "¥Supported CSS"
    }), "\n", _jsx(_components.p, {
      children: "在样式化组件中，我们支持所有 CSS 以及嵌套。由于我们生成实际的样式表而不是内联样式，因此在 CSS 中起作用的任何内容都在样式组件中起作用！"
    }), "\n", _jsx(_components.p, {
      children: "¥Within a styled component, we support all of CSS plus nesting. Since we generate an\nactual stylesheet and not inline styles, whatever works in CSS works in styled-components!"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-react",
        children: "const Example = styled.div`\n  /* all declarations will be prefixed */\n  padding: 2em 1em;\n  background: papayawhip;\n\n  /* pseudo selectors work as well */\n  &:hover {\n    background: #BF4F74;\n  }\n\n  /* media queries are no problem */\n  @media (max-width: 600px) {\n    background: tomato;\n\n    /* nested rules work as expected */\n    &:hover {\n      background: yellow;\n    }\n  }\n\n  > p {\n    /* descendant-selectors work as well, but are more of an escape hatch */\n    text-decoration: underline;\n  }\n\n  /* Contextual selectors work as well */\n  html.test & {\n    display: none;\n  }\n`;\n\nrender(\n  <Example>\n    <p>Hello World!</p>\n  </Example>\n);\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["& 符号 (", _jsx(_components.code, {
        children: "&"
      }), ") 被我们为该样式组件生成的唯一类名所取代，从而可以轻松实现复杂的逻辑。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Ampersands (", _jsx(_components.code, {
        children: "&"
      }), ") get replaced by our generated, unique classname for that styled\ncomponent, making it easy to have complex logic."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
